import { FC, PropsWithChildren, cloneElement, CSSProperties } from 'react';
import classNames from 'classnames';
import { useTheme } from 'styled-components';

import { ThemePaletteColor } from '../../types';

import { TypographyVariant } from './Typography.types';
import {
  TYPOGRAPHY_MAP,
  FONT_SIZE_MAP,
  LINE_HEIGH_MAP,
} from './Typography.const';

import styles from './Typography.module.scss';

export type TypographyProps = PropsWithChildren<{
  bold?: boolean;
  className?: string;
  variant?: TypographyVariant;
  color?: ThemePaletteColor;
  align?: CSSProperties['textAlign'];
}>;

export const Typography: FC<TypographyProps> = ({
  bold,
  align,
  children,
  className,
  variant = 'p1',
  color = 'brown400',
}) => {
  const { fontSize, palette } = useTheme();

  return cloneElement(
    TYPOGRAPHY_MAP[variant],
    {
      className: classNames(
        styles.root,
        styles[variant],
        {
          [styles.bold]: bold,
        },
        className
      ),
      style: {
        textAlign: align,
        color: palette[color],
        fontSize: fontSize(FONT_SIZE_MAP[variant]),
        lineHeight: fontSize(LINE_HEIGH_MAP[variant]),
      },
    },
    children
  );
};
